/**
 * @author vishwadeep.kapoor
 */
import ReactPixel from 'react-facebook-pixel';

/**
 * @desc to add this property we need to add take out the config and add to the project folder
 * fbq('setUserProperties', '283859598862258',
  {
    $state: 'California',
    $city: 'Menlo Park',
    shoeSize: '11',
    shoeWidth: 'D',
    subscription: 'premium'
  }
);
 * @constant `https://developers.facebook.com/docs/facebook-pixel/implementation/user-properties#setting-user-id`
 */
const PIXEL_ID = '452032955002589'; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match

const advancedMatching = {
  uid: 'testing',
};
const options = {
  autoConfig: true,
  debug: false,
};

const initizeFBtracker = () => {
  ReactPixel.init(PIXEL_ID, advancedMatching, options);
};
const trackPageView = () => {
  ReactPixel.pageView();
};
/**
 * @todo: @func trackEvent will be enclosed in other @func
 */
const trackEvent = (event, data) => {
  // const _data = typeof (data) === 'string' ? data : JSON.stringify(data);
  ReactPixel.track(event, data);
};

const EVENT_CONSTANT = {
  VIEWCONTENT: 'ViewContent',
  ADDTOCART: 'AddToCart',
  INITIATECHECKOUT: 'InitiateCheckout',
  PURCHASE: 'Purchase',
};

/**
 * @param {page/product} content_category
 * @param {string/array/arrayOfString}  {content_ids/contents}
 * @param {integer} num_items
 * @param {integer} value
 */
const INITIATE_CHECKOUT = (content_category, content_ids, contents, num_items = 0, value = 0) => {
  trackEvent(EVENT_CONSTANT.INITIATECHECKOUT, {
    content_category,
    content_ids,
    contents,
    value,
    num_items,
    currency: 'INR',
  });
};
/**
 * @param {*string} content_name
 * @param {*string} content_type
 * @param {*Array of integers or strings} content_ids
 * @param {*Array of objects} contents
 * @param {*Integer} value
 */
const VIEW_CONTENT = (content_name, content_type, content_ids, contents, value = 0) => {
  trackEvent(EVENT_CONSTANT.VIEWCONTENT, {
    content_name,
    content_ids,
    content_type,
    contents,
    currency: 'INR',
    value,
  });
};
/**
 * @param {*String} content_name
 * @param {*Array of integers or strings} content_ids
 * @param {*String} content_type
 * @param {*Array of objects} contents
 * @param {*Integer} num_items
 * @param {*Integer} value
 */
const PURCHASE = (content_name, content_ids, content_type, contents, num_items, value = 0) => {
  trackEvent(EVENT_CONSTANT.PURCHASE, {
    content_name,
    content_ids,
    content_type,
    contents,
    currency: 'INR',
    num_items,
    value,
  });
};
/**
 * @param {*String} content_name
 * @param {*Array of integers or strings} content_ids
 * @param {*String} content_type
 * @param {*Array of objects} contents
 * @param {*Integer} value
 */
const ADD_TO_CART = (content_name, content_ids, content_type, contents, value = 0) => {
  trackEvent(EVENT_CONSTANT.ADDTOCART, {
    content_name,
    content_ids,
    content_type,
    contents,
    currency: 'INR',
    value,
  });
};
const FUNCTIONS = { INITIATE_CHECKOUT, VIEW_CONTENT, PURCHASE, ADD_TO_CART, initizeFBtracker, trackPageView };

/**
 * @extends @default EXPORTS
 */
export default { ...FUNCTIONS };



// WEBPACK FOOTER //
// client/devUtils/analytics/fbEventTracker.js